"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountRecordKeeper = void 0;
var AccountRecordKeeper;
(function (AccountRecordKeeper) {
    AccountRecordKeeper["VANGUARD_INSTITUTIONAL"] = "VANGUARD_INSTITUTIONAL";
    AccountRecordKeeper["VANGUARD_RETAIL"] = "VANGUARD_RETAIL";
    AccountRecordKeeper["AGGREGATED"] = "AGGREGATED";
    AccountRecordKeeper["FNZ"] = "FNZ";
    AccountRecordKeeper["CORPORATE_TRUST"] = "CORPORATE_TRUST";
    AccountRecordKeeper["MANUALLY_ENTERED"] = "MANUALLY_ENTERED";
    AccountRecordKeeper["AVQ"] = "AVQ";
    AccountRecordKeeper["VANGUARD_INSTITUTIONAL_OUTSIDE_ASSETS"] = "VANGUARD_INSTITUTIONAL_OUTSIDE_ASSETS";
    AccountRecordKeeper["BETA"] = "BETA";
    AccountRecordKeeper["VISTA"] = "VISTA";
    AccountRecordKeeper["VAST"] = "VAST";
    AccountRecordKeeper["OTHER"] = "Other";
    AccountRecordKeeper["PARTNER_AMEX"] = "PARTNER_AMEX";
})(AccountRecordKeeper = exports.AccountRecordKeeper || (exports.AccountRecordKeeper = {}));
